import { Stack, Typography, useTheme } from "@mui/material";
import { AlertCircle } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	amount: string;
};

export const GoalOwnFundsUncoveredRow: FC<Props> = ({ amount }) => {
	const { colors, iconSize, palette, spacingTokens } = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={spacingTokens.sm}
			px={spacingTokens.lg}
			py={spacingTokens.md}
			bgcolor={palette.amber[50]}
			borderTop={colors.border.solid(palette.amber[100])}
		>
			<AlertCircle
				size={iconSize.sm}
				color={palette.amber[600]}
				style={{ flexShrink: 0 }}
			/>
			<Typography variant="caption" color={palette.amber[700]} tabular>
				{t(Resources.Goals.Detail.OwnFunds.uncovered, { amount })}
			</Typography>
		</Stack>
	);
};
